export default __webpack_public_path__ + "static/Gelion-SemiBold-4eb4aa986bdd847bda0af2cf41625681.woff2";